var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9711 13.8157L17.7457 16.5896C18.5166 17.3602 17.3606 18.5165 16.5898 17.7459L13.8149 14.9718C10.4816 17.721 5.56416 17.5109 2.47425 14.421C-0.824751 11.122 -0.824751 5.77325 2.47425 2.47425C5.77325 -0.824751 11.122 -0.824751 14.421 2.47425C17.5112 5.56445 17.721 10.4825 14.9711 13.8157ZM13.2649 3.6304C10.6044 0.969919 6.29089 0.969919 3.6304 3.6304C0.969919 6.29089 0.969919 10.6044 3.6304 13.2649C6.29089 15.9254 10.6044 15.9254 13.2649 13.2649C15.9254 10.6044 15.9254 6.29089 13.2649 3.6304Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.f2deab6f92420c71ef61ccb59a9ac18c.svg";
export { ForwardRef as ReactComponent };